import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { capacitorLanguageDetector } from './capacitorLanguageDetector';
import { isAndroidCapacitor } from '../utils/platform';

// Create a custom language detector that combines our Capacitor detector
// with the browser detector
const customLanguageDetector = new LanguageDetector();
customLanguageDetector.addDetector(capacitorLanguageDetector);

i18n
  .use(HttpApi)
  .use(customLanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'lt', 'es', 'hi', 'ne', 'pt', 'ru', 'uk'],
    debug: false,
    ns: ['common'],
    defaultNS: 'common',
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    
    detection: {
      // On Android, don't use localStorage for detection to avoid cached language override
      // Only use capacitorLanguageDetector which gets the actual device language
      order: isAndroidCapacitor() 
        ? ['capacitorLanguageDetector', 'navigator', 'htmlTag']
        : ['localStorage', 'capacitorLanguageDetector', 'navigator', 'htmlTag'],
      // Don't cache on Android to always use device language
      caches: isAndroidCapacitor() ? [] : ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    
    react: {
      useSuspense: false // Disable suspense to avoid loading states
    }
  });

export default i18n;